import "@/css/app.css";
import "@/css/global.scss";
import "./boot/axios.js";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/mdi-v7/mdi-v7.css";
import "quasar/src/css/index.sass";
import MainLayout from "@/layouts/MainLayout.vue";
import boot from "./boot/defaultData.js";
import quasarIconSet from "quasar/icon-set/svg-mdi-v7";
import { Quasar, Notify, Dialog, Loading } from "quasar";
import { Ziggy } from "./ziggy.js";
import { ZiggyVue } from "ziggy-js";
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { createPinia } from "pinia";
import { setupInterceptors } from "./boot/setupInterceptors.js";
import laneEs from "quasar/lang/es.js";
import VueDnDKitPlugin from "@vue-dnd-kit/core";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */
import "./echo";

setupInterceptors();

const pinia = createPinia();
createInertiaApp({
    progress: {
        // The delay after which the progress bar will appear, in milliseconds...
        delay: 250,
        // The color of the progress bar...
        color: "#29d",
        // Whether to include the default NProgress styles...
        includeCSS: true,
        // Whether the NProgress spinner will be shown...
        showSpinner: false,
    },
    visitOptions: (href, options) => {
        return { viewTransition: true };
    },
    resolve: (name) => {
        const pages = import.meta.glob("./pages/**/*.vue", { eager: true });
        let page = pages[`./pages/${name}.vue`].default;
        page.layout = page.layout || MainLayout;
        return page;
    },
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(ZiggyVue, Ziggy)
            .use(VueDnDKitPlugin)
            .use(Quasar, {
                lang: laneEs,
                plugins: [Notify, Dialog, Loading],
                iconSet: quasarIconSet,
                extras: ["mdi-v7"],
                config: {
                    brand: {
                        primary: "#245673",
                    },
                    ripple: true,
                },
            })
            .mount(el);
        boot();
    },
});
